export default "__VITE_ASSET__DMn3ix8D__"